import { initSentry } from '@shared/js/sentry';
import { initApp } from '@js/initApp';
import App from '@js/moments/App.vue';

const init = () => {
	const eventId = Number(window.multiFormatEventId);

	if (!Number.isFinite(eventId)) {
		console.error('Moments init aborted: window.multiFormatEventId is missing or invalid');
		return;
	}

	initSentry('Moments');

	return initApp('moments', App, null, null);
};

export { init };
